/**
 * @desc 获取店铺对应的msku月平均价
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.omsFlow.SkuPriceRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/oms/orderStatistics/getOrderAvgPrice`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
